import { render } from "./cpt-scroll-table.vue?vue&type=template&id=2cdfa3a5&scoped=true"
import script from "./cpt-scroll-table.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-table.vue?vue&type=script&lang=js"

import "./cpt-scroll-table.vue?vue&type=style&index=0&id=2cdfa3a5&scoped=true&lang=css"

import exportComponent from "../../../../../.tjp/v1/FEharBh6/xdkj/daping/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.20_vue@3.4.20_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdfa3a5"]])

export default __exports__